import moment from 'moment'

class Datetime {
	static pad(num, size = 2) {
		const nNum = num || 0;
		let s = nNum + "";
		while (s.length < size) s = "0" + s;
		return s;
	}

	static toKey(date) {
		const cDate = {...{ minute: 0, hour: 0, day: 0, month: 0, year: 0 }, ...date}
		return `${this.pad(cDate.year, 4)}${this.pad(cDate.month)}${this.pad(cDate.day)}${this.pad(cDate.hour)}${this.pad(cDate.minute)}`
	}

	static isWeekDayForPill(pill) {
		/*
		momentjs
		1 -> SUNDAY
		2 -> MONDAY
		3 -> TUESDAY
		4 -> WEDNESDAY
		5 -> THURSDAY
		6 -> FRIDAY
		7 -> SATURDAY
		*/
		const weekDay = parseInt(moment().format('E'))

		/*
		idicare
		1 ->  MONDAY
		2 ->  TUESDAY
		4 ->  WEDNESDAY
		8 ->  THURSDAY
		16 -> FRIDAY
		32 -> SATURDAY
		64 -> SUNDAY
		*/
		const weekDayPill = parseInt(pill.week)

		if (weekDay === 1 && (weekDayPill & 64) !== 0) {
			return true
		}
		else if (weekDay === 2 && (weekDayPill & 1) !== 0) {
			return true
		}
		else if (weekDay === 3 && (weekDayPill & 2)!== 0) {
			return true
		}
		else if (weekDay === 4 && (weekDayPill & 4) !== 0) {
			return true
		}
		else if (weekDay === 5 && (weekDayPill & 8) !== 0) {
			return true
		}
		else if (weekDay === 6 && (weekDayPill & 16) !== 0) {
			return true
		}
		else if (weekDay === 7 && (weekDayPill & 32) !== 0) {
			return true
		}

		return false
	}
}

export default Datetime;


// WEBPACK FOOTER //
// ./src/utils/Datetime.js